import StringUtil from "utils/string-util"
import TimeUtil from "utils/time-util"
import React from "react"

const OutboundDealsUrlParamsTableCellService = {
  /**
   * Generate cell content for OutboundDealsUrlParamsTable
   * @param {object} deal - Deal payload (includes payment, user.detail, shipment, sku_list)
   */
  generateDealCellData: (deal) => {
    // Prefer backend-provided sku_list; fallback to cart_items if present
    const skus =
      (Array.isArray(deal.sku_list) && deal.sku_list.length > 0
        ? deal.sku_list
        : (deal.cart?.cart_items || [])
            .map(ci => ci?.product?.sku)
            .filter(Boolean)) || []

    const skuContent =
      skus.length > 0
        ? (
             <div style={{ whiteSpace: 'pre-line', lineHeight: '1.25rem' }}>
              {skus.join('\n')}
            </div>
          )
        : '-'

    return {
      id: {
        content: deal.payment.id
      },
      'payments.created_at': {
        content: TimeUtil.format(deal.payment.created_at, 'DD MMM YY, HH:mm:ss')
      },
      'payments.paid_at': {
        content: deal.payment.paid_at ? TimeUtil.format(deal.payment.paid_at, 'DD MMM YY, HH:mm:ss') : "-"
      },
      'deals.pickup_at': {
        content: deal.pickup_at ? TimeUtil.format(deal.pickup_at, 'DD MMM YY') : "-"
      },
      // REMOVED: 'payments.reference_number'
      'deals.reference_number': {
        content: deal.reference_number
      },
      'users.email': {
        content: deal.user.email
      },
      'user_details.name': {
        content: deal.user.detail.name
      },
      'user_details.phone': {
        content: deal.user.detail?.phone || '-'
      },
      'products.sku_list': {
        content: skuContent
      },
      'deals.final_payment': {
        content: StringUtil.currencyCase(deal.final_payment)
      },
      'deals.down_payment': {
        content: deal.down_payment ? StringUtil.currencyCase(deal.down_payment) : "-"
      },
      'deals.state': {
        content: deal.state
      },
      'deals.note': {
        content: deal.note
      },
    }
  }
}

export default OutboundDealsUrlParamsTableCellService
